import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import {copyManualIdToClipboard, handleManualClick} from "../../utils/manualFinderUtils";
import {IImageManualModel} from "../../types/manualFinder";
import {useTranslation} from "react-i18next";
import {LimitedBadges} from "../../components";

interface ManualRowProps {
    manual: IImageManualModel;
    setIsLoading: (loading: boolean) => void;
}

const ManualRow: React.FC<ManualRowProps> = ({manual, setIsLoading}) => {
    const {t} = useTranslation();

    return (
        <tr>
            <td>
                <div className="d-flex gap-2">
                    {manual.manualId}
                    <FontAwesomeIcon
                        icon={faCopy}
                        className="copy-icon"
                        role="button"
                        onClick={() => copyManualIdToClipboard(manual.manualId, `Copied: ${manual.manualId}`)}
                    />
                </div>
            </td>
            <td>{manual.itemMpText}</td>
            <td>
                <span className="hyper-link" onClick={() => handleManualClick(manual.manualId, setIsLoading, t)}>
                    {manual.manualName}
                </span>
            </td>
            <td>
                {manual.imageFileNameCount} {t("AutomaticImageSelection.outof")} {manual.totalImageCount}
            </td>
            <td><LimitedBadges tools={manual.imageFileNamesFound} labelClass="matched-tool-label"/></td>
        </tr>
    );
};

export default ManualRow;
